var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-navigation-drawer",
    {
      class: ["shadow-left safe-bottom-margin"],
      staticStyle: { "z-index": "10 !important", "max-height": "100%" },
      attrs: {
        width:
          _vm.$vuetify.breakpoint.width < 960 ? "-webkit-fill-available" : 400,
        right: "",
        app: "",
        "mobile-breakpoint": "799",
        permanent: !_vm.$vuetify.breakpoint.smAndDown,
        "disable-resize-watcher": "",
        fullscreen: _vm.$vuetify.breakpoint.width < 960,
        bottom: _vm.$vuetify.breakpoint.width < 960,
        touchless: "",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-col safe-bottom h-full" },
        [
          _c(
            "v-card-title",
            {
              staticClass: "white w-full moveToTop ml-1 soli-grey",
              staticStyle: { flex: "0" },
            },
            [
              _vm._v("\n            Cart\n            "),
              _vm.$vuetify.breakpoint.width < 960
                ? _c(
                    "v-btn",
                    {
                      staticClass: "cancel-btn mr-10 pb-2",
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          return _vm.minimize()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("minimize")])],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "cancel-btn mr-1",
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      _vm.clearCart = true
                    },
                  },
                },
                [_c("v-icon", [_vm._v("clear")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-container",
            {
              class: ["pt-0", _vm.checkout ? "checkout-open" : ""],
              staticStyle: { "flex-grow": "1", "overflow-y": "auto" },
            },
            [
              _c(
                "v-form",
                { ref: "form" },
                [
                  _c(
                    "v-container",
                    { staticClass: "pt-0" },
                    [
                      _c(
                        "v-tabs",
                        {
                          staticClass: "px-1",
                          model: {
                            value: _vm.tabs,
                            callback: function ($$v) {
                              _vm.tabs = $$v
                            },
                            expression: "tabs",
                          },
                        },
                        [
                          _c(
                            "v-tab",
                            {
                              on: {
                                click: function ($event) {
                                  ;[
                                    _vm.$emit("guestCheckout", false),
                                    (_vm.guestEmail = null),
                                  ]
                                },
                              },
                            },
                            [_vm._v("Existing Client")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab",
                            {
                              on: {
                                click: function ($event) {
                                  ;[
                                    _vm.$emit("guestCheckout", true),
                                    (_vm.selectedClient = null),
                                  ]
                                },
                              },
                            },
                            [_vm._v("Guest")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tabs-items",
                    {
                      model: {
                        value: _vm.tabs,
                        callback: function ($$v) {
                          _vm.tabs = $$v
                        },
                        expression: "tabs",
                      },
                    },
                    [
                      _c(
                        "v-tab-item",
                        [
                          _c("SoliStudents", {
                            ref: "students",
                            staticClass: "pt-3 mx-4",
                            attrs: {
                              autocomplete: "",
                              onDemand: "",
                              rules: _vm.rules.select,
                              error: _vm.errors.user_id,
                              label: "Search Billing Accounts",
                              hasEmail: "",
                            },
                            on: {
                              reset: function ($event) {
                                ;[
                                  _vm.$emit("reset"),
                                  _vm.client
                                    ? null
                                    : (_vm.selectedClient = null),
                                  (_vm.skipContracts = false),
                                  (_vm.locationCycle = null),
                                ]
                              },
                              input: _vm.handleClientSelect,
                            },
                            model: {
                              value: _vm.selectedClient,
                              callback: function ($$v) {
                                _vm.selectedClient = $$v
                              },
                              expression: "selectedClient",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tab-item",
                        [
                          _c("SoliText", {
                            staticClass: "px-3 my-3",
                            attrs: {
                              errors: _vm.errors.email,
                              rules: _vm.rules.email,
                              hideDetails: "",
                              icon: "alternate_email",
                              label: "Email",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.openCheckout()
                              },
                            },
                            model: {
                              value: _vm.guestEmail,
                              callback: function ($$v) {
                                _vm.guestEmail = $$v
                              },
                              expression: "guestEmail",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _vm.checkoutLoading
                    ? _c("v-skeleton-loader", {
                        staticClass: "my-3",
                        attrs: {
                          type: "list-item-avatar-three-line",
                          boilerplate: "",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.productsInCart, function (product, index) {
                    return _c(
                      "v-list",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.checkoutLoading,
                            expression: "!checkoutLoading",
                          },
                        ],
                        key: product.price.id,
                      },
                      [
                        _c(
                          "v-list-item",
                          { staticClass: "flex justify-between" },
                          [
                            _c(
                              "v-list-item-content",
                              { staticClass: "py-0" },
                              [
                                _c("v-list-item-title", [
                                  _vm._v(
                                    _vm._s(product.name) +
                                      "\n                            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "v-list-item-subtitle",
                                  {
                                    staticClass: "caption",
                                    staticStyle: { "max-width": "75%" },
                                  },
                                  [_vm._v(_vm._s(product.description))]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "v-list-item-title",
                                  { staticClass: "justify-end flex" },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          `${
                                            product.price.interval
                                              ? `${_vm.formatUnitAmount(
                                                  product.proration
                                                )}`
                                              : product.formatAmount
                                          }`
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                product.unpaidPO && _vm.selectedClient
                                  ? _c(
                                      "v-list-item-subtitle",
                                      { staticClass: "caption error--text" },
                                      [
                                        product.unpaidPO
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "justify-end flex",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      `Unpaid from Account X ${
                                                        _vm.unpaidPOs.filter(
                                                          (e) =>
                                                            e.price_id ==
                                                              product.price
                                                                .id ||
                                                            e.price_id ==
                                                              product.price
                                                                .originalPrice
                                                        ).length
                                                      }`
                                                    ) +
                                                    "\n                                "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                product.price.interval &&
                                (!product.price.coupon_duration ||
                                  product.price.coupon_duration == "forever")
                                  ? _c("v-list-item-subtitle", [
                                      _c(
                                        "div",
                                        { staticClass: "justify-end flex" },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                `then ${_vm.formatUnitAmount(
                                                  product.price.unit_amount
                                                )}/month`
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                product.price.interval &&
                                product.price.coupon_duration &&
                                product.price.coupon_duration !== "forever"
                                  ? _c("v-list-item-subtitle", [
                                      _c(
                                        "div",
                                        { staticClass: "justify-end flex" },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                `${_vm.formatUnitAmount(
                                                  product.price.unit_amount
                                                )}/month ${
                                                  product.price.coupon_duration
                                                    ? `(${product.price.coupon_duration} months)`
                                                    : ""
                                                }`
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                product.price.interval &&
                                product.price.coupon_duration &&
                                product.price.coupon_duration !== "forever"
                                  ? _c("v-list-item-subtitle", [
                                      _c(
                                        "div",
                                        { staticClass: "justify-end flex" },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                `then ${_vm.formatUnitAmount(
                                                  product.prices.find(
                                                    (e) =>
                                                      e.id ==
                                                      product.price
                                                        .originalPrice
                                                  ).unit_amount
                                                )}/month`
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                product.price.interval &&
                                product.proration == null
                                  ? _c(
                                      "div",
                                      { staticClass: "justify-end flex" },
                                      [
                                        _c("v-progress-circular", {
                                          staticClass: "justify-self-end",
                                          attrs: {
                                            indeterminate: "",
                                            size: 25,
                                            color: "primary",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        product.price.tags
                          ? _c(
                              "div",
                              { staticClass: "px-4" },
                              [
                                _c("v-list-item-subtitle", [
                                  _c(
                                    "div",
                                    { staticClass: "justify-start flex gap-1" },
                                    _vm._l(product.price.tags, function (tag) {
                                      return _c(
                                        "v-chip",
                                        {
                                          key: tag.id,
                                          staticClass:
                                            "white--text text-capitalize",
                                          attrs: {
                                            "x-small": "",
                                            color: tag.color,
                                          },
                                        },
                                        [_vm._v(_vm._s(tag.name))]
                                      )
                                    }),
                                    1
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        product.price.interval
                          ? _c(
                              "v-list-item",
                              [
                                _c("v-divider", {
                                  staticClass: "mr-2 my-1",
                                  staticStyle: {
                                    "border-color": "#78b2e9",
                                    "border-width": "1px",
                                    "border-radius": "12px",
                                  },
                                  attrs: { vertical: "" },
                                }),
                                _vm._v(" "),
                                _c(
                                  "v-list",
                                  { staticClass: "py-0 w-full" },
                                  [
                                    product.futureDateMembership
                                      ? _c(
                                          "v-list-item-subtitle",
                                          {
                                            staticClass:
                                              "flex justify-between w-full",
                                          },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    `Due ${_vm.globalMomentDate(
                                                      new Date(product.anchor)
                                                    )}:`
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("v-spacer"),
                                            _vm._v(" "),
                                            product.futureDateMembership
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex justify-end",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          `${_vm.formatUnitAmount(
                                                            product
                                                              .futureDateMembership
                                                              .proration
                                                          )}`
                                                        ) +
                                                        "\n                                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    product.starts_at
                                      ? _c(
                                          "v-list-item-subtitle",
                                          {
                                            staticClass:
                                              "flex justify-between w-full",
                                          },
                                          [
                                            _c("div", [
                                              _vm._v("Proration Period:"),
                                            ]),
                                            _vm._v(" "),
                                            _c("v-spacer"),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "flex justify-end",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      `${_vm.globalMomentDate(
                                                        new Date(
                                                          product
                                                            .futureDateMembership
                                                            ?.starts_at ??
                                                            product.starts_at
                                                        ),
                                                        "MMM D"
                                                      )} to ${_vm.globalMomentDate(
                                                        new Date(
                                                          product
                                                            .futureDateMembership
                                                            ?.anchor ??
                                                            product.anchor
                                                        )
                                                      )}`
                                                    ) +
                                                    "\n                                "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    product.price.interval
                                      ? _c(
                                          "v-list-item-subtitle",
                                          {
                                            staticClass:
                                              "flex justify-between w-full",
                                          },
                                          [
                                            _vm._v("Auto-billing Begins:"),
                                            _c("v-spacer"),
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.getBillingStart(product)
                                                )
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    product.price.interval && false
                                      ? _c(
                                          "v-list-item-subtitle",
                                          {
                                            staticClass:
                                              "flex justify-between w-full",
                                          },
                                          [
                                            _c("div", [
                                              _vm._v("Customer Terms Accepted"),
                                            ]),
                                            _vm._v(" "),
                                            _c("v-spacer"),
                                            _vm._v(" "),
                                            _c(
                                              "v-icon",
                                              {
                                                class: [
                                                  "pr-1",
                                                  product.contracts.every(
                                                    (e) => e.signed
                                                  )
                                                    ? "primary--text"
                                                    : "error--text",
                                                ],
                                                attrs: { small: "" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    product.contracts.every(
                                                      (e) => e.signed
                                                    )
                                                      ? "done_all"
                                                      : "error"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "v-list-item",
                          { staticStyle: { "margin-top": "-8px" } },
                          [
                            _c(
                              "v-list-item-subtitle",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      small: "",
                                      icon: "",
                                      color: "dark",
                                    },
                                    on: {
                                      click: function ($event) {
                                        ;[
                                          _vm.$emit("decrement", product),
                                          product.recipients.length >
                                          product.quantity
                                            ? product.recipients.pop()
                                            : null,
                                        ]
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("remove"),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "px-2 soli-grey-text" },
                                  [_vm._v(_vm._s(product.quantity))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      small: "",
                                      icon: "",
                                      color: "dark",
                                      disabled: product.unpaid,
                                    },
                                    on: {
                                      click: function ($event) {
                                        ;[
                                          _vm.$emit("increment", product),
                                          _vm.selectedClient
                                            ? _vm.selectedClient.relationships
                                                .length > 0
                                              ? null
                                              : product.recipients.push(
                                                  _vm.selectedClient
                                                )
                                            : null,
                                        ]
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("add"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("v-spacer"),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex" },
                              [
                                _vm.can("Override membership proration") &&
                                product.price.interval
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          small: "",
                                          icon: "",
                                          color: product.doNotBill
                                            ? "primary"
                                            : "dark",
                                        },
                                        on: {
                                          click: function ($event) {
                                            product.doNotBill
                                              ? ((_vm.membershipStart = _vm
                                                  .moment()
                                                  .startOf("day")
                                                  .format()),
                                                _vm.handleChangeMembershipStart(
                                                  product
                                                ),
                                                _vm.$emit(
                                                  "reload",
                                                  _vm.locationCycle
                                                ))
                                              : (_vm.doNotBill = product)
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("money_off"),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                product.price.interval &&
                                _vm.can("Override membership start date")
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          small: "",
                                          icon: "",
                                          color: "dark",
                                          disabled: product.doNotBill,
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.changeMembershipStart = product
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("today"),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.can("Override product prices")
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          small: "",
                                          icon: "",
                                          color: "dark",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.$emit(
                                              "createInlinePrice",
                                              product
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("edit"),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.can("Override membership start date")
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          small: "",
                                          icon: "",
                                          color: "dark",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.$emit(
                                              "removeFromCart",
                                              product
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("delete_outline"),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.selectedClient &&
                        _vm.selectedClient.relationships.length &&
                        !product.physical
                          ? _c(
                              "div",
                              { staticClass: "mb-4 flex flex-col gap-2" },
                              _vm._l(
                                [...Array(product.quantity)].map((_, i) => i),
                                function (quantity, idx) {
                                  return _c(
                                    "v-list-item",
                                    { key: quantity },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          rules: _vm.rules.select,
                                          outlined: "",
                                          "return-object": "",
                                          items: [
                                            _vm.selectedClient,
                                            _vm.selectedClient.relationships,
                                          ].flatMap((e) => e),
                                          // if unpaidPO has recipient and it's the first item in the cart at the first index
                                          value: _vm.unpaidPOs.length
                                            ? _vm.productsInCart[index]
                                                .recipients.length
                                              ? _vm.productsInCart[index]
                                                  .recipients[idx]
                                              : null
                                            : null,
                                          disabled:
                                            _vm.productsInCart[index]
                                              .unpaidPO &&
                                            _vm.productsInCart[index].recipients
                                              .length
                                              ? _vm.unpaidPOs.filter(
                                                  (e) =>
                                                    e.price.id ==
                                                    _vm.productsInCart[index]
                                                      .price.id
                                                ).length -
                                                  idx >
                                                0
                                              : false,
                                          dense: "",
                                          "item-text": "name",
                                          "item-value": "id",
                                          "prepend-inner-icon": "people",
                                          label: "Purchase for...",
                                          "hide-details": "auto",
                                        },
                                        on: {
                                          change: function ($event) {
                                            ;[
                                              product.recipients.splice(
                                                idx,
                                                1,
                                                $event
                                              ),
                                              _vm.openCheckout(),
                                            ]
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("v-divider"),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    { staticClass: "px-2", attrs: { dense: "" } },
                    [
                      _c(
                        "v-list-item",
                        [
                          _c("v-list-item-subtitle", [_vm._v("Subtotal")]),
                          _vm._v(" "),
                          _c("v-list-item-action", [
                            _vm._v(_vm._s(_vm.formatUnitAmount(_vm.subtotal))),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.activePromos.length > 0
                        ? _c(
                            "div",
                            _vm._l(_vm.activePromos, function (promo) {
                              return _c(
                                "v-list-item",
                                { key: promo.id, staticClass: "pr-2" },
                                [
                                  _c("v-list-item-subtitle", [
                                    _vm._v(
                                      _vm._s(`${promo.code} · ${promo.name}`)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-action",
                                    {
                                      staticClass: "justify-end",
                                      staticStyle: { width: "100%" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          `- ${_vm.formatUnitAmount(
                                            promo.amount
                                          )}`
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        { staticClass: "pr-2" },
                        [
                          _c("v-list-item-subtitle", [_vm._v("Tax")]),
                          _vm._v(" "),
                          _c(
                            "v-list-item-action",
                            {
                              staticClass: "justify-end",
                              staticStyle: { width: "100%" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  `${
                                    _vm.getTaxes
                                      ? _vm.formatUnitAmount(_vm.getTaxes)
                                      : ""
                                  }`
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.selectedClient
                        ? _c(
                            "div",
                            [
                              _vm.showClientBalance
                                ? _c(
                                    "v-list-item",
                                    { staticClass: "pr-2" },
                                    [
                                      _c("v-list-item-subtitle", [
                                        _vm._v("Account Balance"),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-item-action",
                                        {
                                          staticClass: "justify-end",
                                          staticStyle: { width: "100%" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              `- ${_vm.formatUnitAmount(
                                                _vm.calculateClientBalance
                                              )}`
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        [
                          _c("v-list-item-title", [_vm._v("Total")]),
                          _vm._v(" "),
                          _c(
                            "v-list-item-action",
                            { staticClass: "font-bold" },
                            [
                              _vm._v(
                                _vm._s(_vm.formatUnitAmount(_vm.finalPrice))
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.productsInCart.length > 0 &&
          _vm.requiresContract &&
          !_vm.signedContracts
            ? _c(
                "v-card",
                {
                  class: [
                    "w-full half-round",
                    _vm.$vuetify.breakpoint.mdAndUp ? "pb-3" : null,
                  ],
                  staticStyle: { flex: "0", position: "relative" },
                },
                [
                  _c("v-card-title", { staticClass: "px-6 soli-grey" }, [
                    _vm._v("Policies"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    { staticClass: "flex justify-end" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "soli-round",
                          attrs: {
                            plain: "",
                            color: "error",
                            disabled: !_vm.selectedClient || !_vm.validCheckout,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleSkipContracts()
                            },
                          },
                        },
                        [_vm._v("Skip for now")]
                      ),
                      _vm._v(" "),
                      _c(
                        "SoliBtn",
                        {
                          staticClass: "soli-round",
                          attrs: {
                            disabled: !_vm.selectedClient || !_vm.validCheckout,
                            loading: _vm.loading,
                            color: "primary",
                            gradient: "blue",
                          },
                          on: {
                            click: function ($event) {
                              ;[_vm.getContracts(), (_vm.loadContract = true)]
                            },
                          },
                        },
                        [_vm._v("Review and Sign")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          (_vm.selectedClient || _vm.guestEmail) &&
          _vm.productsInCart.length > 0 &&
          (!_vm.requiresContract || _vm.signedContracts)
            ? _c("Checkout", {
                ref: "checkout",
                attrs: {
                  rules: _vm.rules,
                  client: _vm.guestEmail
                    ? { email: _vm.guestEmail }
                    : _vm.selectedClient,
                  prices: _vm.productsInCart,
                  dialog: _vm.checkout,
                  errors: _vm.errors,
                  subtotal: _vm.subtotal,
                  total: _vm.finalPrice,
                  unpaidPOs: _vm.unpaidPOs,
                  activePromos: _vm.activePromos,
                  defaultMethod: _vm.defaultMethod,
                  checkoutLoading: _vm.checkoutLoading,
                  selectedTab: _vm.selectedTab,
                  taxRate: _vm.taxRate,
                  contracts: _vm.productsInCart
                    .filter((e) => e.contracts)
                    .map((e) => e.contracts)
                    .flat(),
                  guestCheckout: _vm.guestCheckout,
                },
                on: {
                  reset: function ($event) {
                    _vm.checkout = false
                  },
                  applyPromo: _vm.applyPromo,
                  clearPromo: _vm.clearPromo,
                  success: function ($event) {
                    ;[_vm.getStripeClient(), _vm.$emit("success")]
                  },
                  guestCheckout: function ($event) {
                    _vm.$emit("guestCheckout"),
                      (_vm.tabs = 0),
                      (_vm.guestEmail = null)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.loadContract
            ? _c("Contracts", {
                attrs: { contracts: _vm.contracts, client: _vm.selectedClient },
                on: {
                  success: _vm.handleContractSuccess,
                  reset: function ($event) {
                    _vm.loadContract = false
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.changeMembershipStart
            ? _c("SoliChoice", {
                attrs: {
                  title: "STOP.",
                  subtitle:
                    "You’re about to change the membership start date. In most cases you don’t need to do this.",
                  button1: "Do It Anyway",
                  warning: "",
                  button2: "Nevermind",
                },
                on: {
                  option1: function ($event) {
                    _vm.confirmChangeMembershipStart = _vm.changeMembershipStart
                  },
                  reset: function ($event) {
                    _vm.changeMembershipStart = false
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.confirmChangeMembershipStart
            ? _c("SoliForm", {
                ref: "membershipStart",
                attrs: {
                  title: "Change Membership Start Date",
                  textSubtitle: `Membership can be set to begin anytime between now and the end of ${
                    _vm.can("Future date memberships") ? "next" : "the"
                  } month.`,
                  text: "Confirm",
                  icon: "save",
                  saveChanges: _vm.membershipStart ? true : false,
                },
                on: {
                  reset: function ($event) {
                    _vm.confirmChangeMembershipStart = false
                  },
                  submit: function ($event) {
                    return _vm.handleChangeMembershipStart(
                      _vm.confirmChangeMembershipStart
                    )
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function () {
                        return [
                          _c("SoliDate", {
                            attrs: {
                              select: false,
                              future: "",
                              max: _vm.can("Future date memberships")
                                ? _vm.globalMomentEndOfNextMonth(new Date())
                                : _vm.globalMomentEndOfMonth(new Date()),
                            },
                            model: {
                              value: _vm.membershipStart,
                              callback: function ($$v) {
                                _vm.membershipStart = $$v
                              },
                              expression: "membershipStart",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  186836572
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.doNotBill
            ? _c("SoliChoice", {
                attrs: {
                  title: "STOP.",
                  subtitle: `This will skip prorating the current month. You are about to give away free lessons. Billing will start on ${_vm.getBillingStart(
                    _vm.doNotBill
                  )}`,
                  button1: "Do it anyway",
                  button2: "Nevermind",
                  warning: "",
                },
                on: {
                  option1: function ($event) {
                    return _vm.handleDoNotBill(_vm.doNotBill)
                  },
                  reset: function ($event) {
                    _vm.doNotBill = null
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.clearCart
            ? _c("SoliChoice", {
                attrs: {
                  title: "Remove all items from cart?",
                  button1: "Clear",
                  button2: "Nevermind",
                },
                on: {
                  option1: function ($event) {
                    ;[
                      _vm.$emit("reset"),
                      (_vm.selectedClient = null),
                      (_vm.skipContracts = false),
                    ]
                  },
                  reset: function ($event) {
                    ;[
                      (_vm.clearCart = false),
                      _vm.$refs.checkout
                        ? (_vm.$refs.checkout.loading = false)
                        : null,
                    ]
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.pastDue
            ? _c("SoliChoice", {
                attrs: {
                  title: "Account Past Due",
                  subtitle:
                    "This client has a past due subscription and is unable to make additional purchases",
                  button1: "Okay",
                },
                on: {
                  option1: function ($event) {
                    _vm.$inertia.visit(_vm.route("store"))
                  },
                  reset: function ($event) {
                    _vm.$inertia.visit(_vm.route("store"))
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.locationWarning
            ? _c("SoliChoice", {
                attrs: {
                  title: "hold up.",
                  subtitle: `${_vm.selectedClient.name} doesn't belong to this location.`,
                  button1:
                    _vm.selectedClient.locations.length == 1
                      ? `Switch to ${_vm.selectedClient.locations[0].name}`
                      : "Change Locations",
                  button2: "Go Back",
                  loading1: "",
                  permanent: "",
                },
                on: {
                  option1: function ($event) {
                    return _vm.$emit("locationSelect", _vm.selectedClient)
                  },
                  option2: function ($event) {
                    _vm.$inertia.visit(_vm.route("store"))
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }